// data base team
export default [
  {
    url: "/back",
    name: "분야 바로가기",
    icon: "ArrowLeftIcon",
    activeCode: "",
  },
  {
    url: "/home",
    name: "대시보드",
    icon: "",
    activeCode: "",
  },
  {
    url: "/",
    name: "사업장 현황",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/field/workplace-insider",
        name: "직영사업장",
        icon: "w-line",
        activeCode: "field-workplace-insider",
      },
    ],
  },
  {
    url: "/",
    name: "위험성평가",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/450",
        name: "정기 위험성평가",
        icon: "w-line",
        activeCode: "riskassessment450",
        groupName: ["450", "riskassessment450"],
      },
      {
        url: "/tab/460",
        name: "수시 위험성평가",
        icon: "w-line",
        activeCode: "riskassessment460",
        groupName: ["460", "riskassessment460"],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 위험성평가 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/tab/161",
        name: "건설업(농협)",
        icon: "w-line",
        activeCode: "",
        groupName: ["161"],
      },
      {
        url: "/tab/475",
        name: "위험성평가(3등급)",
        icon: "w-line",
        activeCode: "",
        groupName: ["475"],
      },
      {
        url: "/",
        name: "교육서비스업",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 사고사례 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "2023년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2022년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2021년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/",
    name: "MAOT 산재관련 D/B",
    icon: "",
    activeCode: "",
    submenu: [
      {
        url: "/",
        name: "2023년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2022년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "2021년",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
      {
        url: "/",
        name: "...",
        icon: "w-line",
        activeCode: "",
        // groupName: [""],
      },
    ],
  },
  {
    url: "/mypage",
    name: "마이페이지",
    slug: "safety",
    icon: "",
    submenu: [
      {
        url: "/mypage/workstatus",
        name: "업무현황",
        slug: "",
        icon: "w-line",
        groupName: ["90"],
      },
      {
        url: "/mypage/alert",
        name: "알림",
        slug: "",
        icon: "w-line",
        groupName: ["91"],
      },
      {
        url: "/",
        name: "설정",
        slug: "",
        icon: "w-line",
        submenu: [
          {
            url: "/mypage/info-update",
            name: "개인정보변경",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
          {
            url: "/mypage/sign-update",
            name: "개인서명관리",
            slug: "",
            icon: "w-line",
            groupName: ["92"],
          },
        ],
      },
    ],
  },
];
